const percent_farm = (state = null, action) => {
  switch (action.type) {
    case "GET_PERCENT_FARM":
      return action.payload;
    default:
      return state;
  }
};

export default percent_farm;
